import './styles/styles.css';
import game from './modules/game';

game.init();
